import React, { FC } from "react";
import Toolbar from "../F7/Toolbar";
import config from "../../../config";
import { useLastInventoryId } from "../../../state";
import { useCurrentDatabaseId } from "../../../hooks/url";
import { useListProjects } from "../../../hooks/database/usePouchList";

type Link = {
  label: string;
  active: boolean;
  icon: string;
  to: string;
  showOnWeb: boolean;
};

const defaultLinks: Link[] = [
  {
    label: "OFFLINE",
    active: false,
    icon: "fa fa-download",
    to: "offline-maps",
    showOnWeb: false,
  },
  {
    label: "SYNC",
    active: false,
    icon: "fa fa-retweet",
    to: "/sync",
    showOnWeb: false,
  },
];

const useOptionallyAddProjectsLink = (links: Link[]): Link[] => {
  const currentDatabaseId = useCurrentDatabaseId();
  let db = currentDatabaseId?.databaseId;
  if (db) {
    links.unshift({
      label: "PROJECTS",
      active: false,
      icon: "fa fa-cubes",
      to: `/d/${db}/p`,
      showOnWeb: true,
    });
  }

  return links;
};

const useOptionallyAddMapLink = (links: Link[]): Link[] => {
  const curDbIdObj = useCurrentDatabaseId();
  const lastInventoryId = useLastInventoryId();
  const { data: projects } = useListProjects();
  if (projects) {
    const lastProject = lastInventoryId === null ? undefined : projects.find((p) => p.inventories && lastInventoryId in p.inventories);
    const lastInventory = lastInventoryId === null ? undefined : lastProject?.inventories?.[lastInventoryId];

    if (lastInventory) {
      links.unshift({
        label: "MAP",
        active: false,
        icon: "fa fa-globe",
        to: `/d/${curDbIdObj.databaseId}/i/${lastInventoryId}`,
        showOnWeb: true,
      });
    }
  }

  return links;
};

const ToolbarBottom: FC = () => {
  let links = defaultLinks.filter((link) => config.isApp || link.showOnWeb);

  links = useOptionallyAddProjectsLink(links);
  links = useOptionallyAddMapLink(links);

  return <Toolbar links={links} />;
};

export default ToolbarBottom;
